import React, { useState } from 'react'
import { Route, Redirect } from 'react-router-dom'

export const ProtectedRoute = ({ component: Component, ...rest }) => {
  let config = {}
  if (rest.config) {
    config = rest.config()
  }
  return (
    <Route
      {...rest}
      render={props => {
        if (localStorage.token) {
          return <Component {...props} config={config} />
        } else {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: {
                  from: props.location
                }
              }}
            />
          )
        }
      }}
    />
  )
}
